import { IdProvider } from './provider';

export const createFallbackIdProvider = (providers: IdProvider[]): IdProvider => ({
  async get(): Promise<string | null> {
    for (const provider of providers) {
      const id = await provider.get();
      if (id) return id;
    }

    return null;
  },
});
